const initializePearlInfiniteProducts = () => {
  const grids = document.querySelectorAll('[data-infinite-products]');
  if (!grids.length || !('IntersectionObserver' in window)) return;

  grids.forEach((grid) => {
    const sentinel = grid.parentElement.querySelector('[data-infinite-sentinel]');
    if (!sentinel || !grid.dataset.nextUrl) return;

    let loading = false;

    const loadNextPage = async () => {
      if (loading || !grid.dataset.nextUrl) return;
      loading = true;
      grid.classList.add('is-loading-more');

      try {
        const nextUrl = new URL(grid.dataset.nextUrl, window.location.href);
        const sourcePageUrl = new URL(nextUrl.toString());
        const currentUrl = new URL(window.location.href);
        ['preview_theme_id', '_fd'].forEach((parameter) => {
          if (currentUrl.searchParams.has(parameter) && !nextUrl.searchParams.has(parameter)) {
            nextUrl.searchParams.set(parameter, currentUrl.searchParams.get(parameter));
          }
        });
        nextUrl.searchParams.set('section_id', grid.dataset.sectionId);
        const response = await fetch(nextUrl.toString(), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error(`Infinite product load failed: ${response.status}`);

        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = documentFragment.querySelector('[data-infinite-products]');
        if (!nextGrid) throw new Error('Infinite product grid was not found.');

        [...nextGrid.children].forEach((card) => {
          const productCard = card.matches?.('.product-card') ? card : card.querySelector?.('.product-card');
          if (productCard) productCard.dataset.productSourceUrl = sourcePageUrl.pathname + sourcePageUrl.search;
          grid.appendChild(card);
        });
        grid.dataset.nextUrl = nextGrid.dataset.nextUrl || '';

        if (!grid.dataset.nextUrl) {
          sentinel.remove();
        }
      } catch (error) {
        console.warn('Unable to load more series products.', error);
        sentinel.remove();
      } finally {
        loading = false;
        grid.classList.remove('is-loading-more');
      }
    };

    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) loadNextPage();
    }, { rootMargin: '700px 0px' });

    observer.observe(sentinel);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializePearlInfiniteProducts, { once: true });
} else {
  initializePearlInfiniteProducts();
}
